import http from "@/utils/request";

export function doLogin(data: Req.doLogin) {
  return http.post<Res.response<Res.doLogin>>({
    url: "/login/doLogin",
    data,
  });
}

export function getMerchantResourceDto(data: string) {
  return http.get<Res.response<any>>({
    url: "/merchant/sys/role/info/" + data,
  });
}
